"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import Lottie from "react-lottie-player";
import animationData from "../../../../../public/lotties/globee-awards-banner.json";
import animationData2 from "../../../../../public/lotties/witsa-awards.json";
import "swiper/css";

const HeroSection = () => {
  const t = useTranslations("about-us");
  const dataHero = {
    title: t("about-us"),
    subtitle: t(
      "hyra-network-fosters-an-inclusive-ai-ecosystem-with-innovation-collaboration-and-sustainability",
    ),
    awards: [
      // {
      //   image: "/images/about-us/image_awards_hero.png",
      //   title: "Globee Awards Gold Winner 2025",
      //   subtitle: "Technology Startups of the Year",
      //   href: "/en/news/hyra-network-wins-prestigious-chairman-s-award-2025-at-witsa-global-ai-summit-63",
      //   animationData: animationData2,
      // },
      {
        image: "/images/about-us/image_awards_hero.png",
        title: "Globee Awards Gold Winner 2025",
        subtitle: "Technology Startups of the Year",
        href: "/en/news/hyra-network-honored-as-technology-startup-of-the-year-at-the-2025-globee-awards-44",
        animationData: animationData,
      },
    ],
  };

  return (
    <div className="px-4 md:px-10 lg:px-20 xl:px-[78px]">
      {/* Phần chữ */}
      <div className="flex flex-col items-center justify-between gap-y-6 pb-10 pt-[52px] sm:gap-y-12 sm:px-20 xl:flex-row xl:gap-x-[242px] xl:px-0">
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
          className="space-y-4 text-center xl:text-left"
        >
          <h1 className="text-3xl font-normal leading-tight text-black md:text-5xl xl:text-[56px]">
            {dataHero.title}
          </h1>
          <p className="text-base font-light text-[#000000] md:text-lg">
            {dataHero.subtitle}
          </p>
        </motion.div>

        {/* Awards */}
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
          viewport={{ once: false, amount: 0.3 }}
          className="w-full space-y-4 xl:w-auto"
        >
          {dataHero.awards.map((item, index) => (
            <Link
              key={index}
              href={item.href}
              className="flex w-full items-center justify-between gap-3 rounded-2xl bg-[#FFFFFF] px-1 py-1 sm:min-w-[300px] sm:rounded-[32px] md:min-w-[380px] xl:min-w-[410px]"
            >
              <Lottie
                play
                loop
                style={{ filter: "invert(1)" }}
                animationData={item.animationData}
                className="h-full w-full"
              />
            </Link>
          ))}
        </motion.div>
      </div>

      {/* Phần ảnh */}
      <div
        className="relative flex w-auto items-center gap-x-4 overflow-auto max-sm:hidden sm:mx-auto sm:w-full sm:justify-between sm:gap-6 sm:overflow-hidden sm:rounded-[40px] sm:py-[38px] md:px-8 xl:h-[407px] xl:max-w-[1278px] xl:rounded-[64px] xl:px-20"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        <div className="pointer-events-none absolute inset-0 z-0 hidden sm:block">
          <Image
            src={"/images/backgrounds/backgrounds_aboutUs.png"}
            fill
            className="object-cover"
            alt={"BackGround Hero"}
          />
        </div>
        <div className="absolute left-[-100px] top-0 z-10 hidden h-[200px] w-[200px] bg-gradient-to-b from-[#0066FF] to-[#BFB4FC] blur-[400px] sm:block md:left-[-174px] md:h-[327px] md:w-[327px] md:blur-[800px]"></div>
        <div className="absolute right-[-100px] top-0 z-10 hidden h-[200px] w-[200px] bg-gradient-to-b from-[#0066FF] to-[#BFB4FC] blur-[400px] sm:block md:right-[-174px] md:h-[327px] md:w-[327px] md:blur-[800px]"></div>

        <motion.div
          initial={{ y: 100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
          className="relative z-20 hidden h-[300px] w-[300px] justify-center rounded-3xl bg-[#FFFFFF80] sm:flex sm:h-[325px] sm:w-[325px] sm:rounded-[40px]"
        >
          <Image
            src={"/images/about-us/hyra_network_awards.gif"}
            className="object-cover"
            width={250}
            height={200}
            alt={"Hyra Network Awards"}
          />
        </motion.div>

        <motion.div
          initial={{ y: 100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: false, amount: 0.3 }}
          className="relative z-20 hidden h-[300px] w-[300px] justify-center rounded-3xl bg-[#FFFFFF80] sm:flex sm:h-[325px] sm:w-[325px] md:rounded-[40px]"
        >
          <Image
            src={"/images/gif/witsa-global-awards.gif"}
            className="object-cover"
            width={250}
            height={200}
            alt={"Hyra Network Awards"}
          />
        </motion.div>

        <div className="relative h-[312px] min-w-[280px] select-none overflow-hidden rounded-[55px] px-[26px] py-[30px] sm:hidden">
          <div className="pointer-events-none absolute inset-0 z-0 sm:hidden">
            <Image
              src={"/images/backgrounds/backgrounds_aboutUs.png"}
              fill
              className="object-cover"
              alt={"BackGround Hero"}
            />
          </div>
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            viewport={{ once: true }}
            className="relative z-20 flex h-[252px] w-[228px] justify-center rounded-3xl bg-[#FFFFFF80] sm:rounded-[40px]"
          >
            <Image
              src={"/images/about-us/hyra_network_awards.gif"}
              className="object-cover"
              width={250}
              height={200}
              alt={"Hyra Network Awards"}
            />
          </motion.div>
        </div>

        <div className="relative h-[312px] min-w-[280px] select-none overflow-hidden rounded-[55px] px-[26px] py-[30px] sm:hidden">
          <div className="pointer-events-none absolute inset-0 z-0 sm:hidden">
            <Image
              src={"/images/backgrounds/backgrounds_aboutUs.png"}
              fill
              className="object-cover"
              alt={"BackGround Hero"}
            />
          </div>
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            viewport={{ once: true }}
            className="relative z-20 flex h-[252px] w-[228px] justify-center rounded-3xl bg-[#FFFFFF80] sm:rounded-[40px]"
          >
            <Image
              src={"/images/about-us/hyra_network_awards.gif"}
              className="object-cover"
              width={250}
              height={200}
              alt={"Hyra Network Awards"}
            />
          </motion.div>
        </div>
      </div>

      {/* Mobile */}
      <div className="mt-10 sm:hidden">
        <Swiper
          modules={[FreeMode]}
          freeMode={{ enabled: true }}
          slidesPerView="auto"
          spaceBetween={16}
          grabCursor
          className="!overflow-visible px-4"
        >
          <SwiperSlide className="!w-auto overflow-hidden rounded-[40px] p-6">
            <div className="pointer-events-none absolute inset-0 z-0">
              <Image
                src={"/images/backgrounds/backgrounds_aboutUs.png"}
                fill
                className="object-cover"
                alt={"BackGround Hero"}
              />
            </div>
            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.9, ease: "easeOut" }}
              viewport={{ once: false, amount: 0.3 }}
              className="relative z-20 flex h-[250px] w-[228px] justify-center rounded-3xl bg-[#FFFFFF80] backdrop-blur-sm sm:rounded-[40px]"
            >
              <Image
                src={"/images/about-us/hyra_network_awards.gif"}
                className="object-cover"
                fill
                alt={"Hyra Network Awards"}
              />
            </motion.div>
          </SwiperSlide>

          <SwiperSlide className="!w-auto overflow-hidden rounded-[40px] p-6">
            <div className="pointer-events-none absolute inset-0 z-0">
              <Image
                src={"/images/backgrounds/backgrounds_aboutUs.png"}
                fill
                className="object-cover"
                alt={"BackGround Hero"}
              />
            </div>
            <motion.div
              initial={{ y: 100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.9, ease: "easeOut" }}
              viewport={{ once: false, amount: 0.3 }}
              className="relative z-20 flex h-[250px] w-[228px] justify-center rounded-3xl bg-[#FFFFFF80] backdrop-blur-sm sm:rounded-[40px]"
            >
              <Image
                src={"/images/gif/witsa-global-awards.gif"}
                className="object-cover"
                fill
                alt={"Hyra Network Awards"}
              />
            </motion.div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default HeroSection;
